module.exports = __webpack_public_path__ + "static/img/categoryIntro.006d039.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/categoryIntro.png
// module id = SY+3
// module chunks = 3